<template>
  <div>
    <el-dialog
      title="查看日志"
      :visible.sync="visible"
      width="50%"
      top="6vh"
      :close-on-click-modal="false"
    >
      <el-scrollbar class="default-scrollbar" v-loading="loading">
        <el-timeline>
          <el-timeline-item
            placement="top"
            v-for="item in logs"
            :key="item.id"
            :timestamp="moment(item.addTime).format('YYYY-MM-DD HH:mm:ss')"
          >
            <el-card>
              <h4>
                {{ item.shortMessage }}
                {{ item.fullMessage }}
              </h4>
              <p>{{ item.deptName }} {{ item.fullName }}</p>
            </el-card>
          </el-timeline-item>
        </el-timeline>
      </el-scrollbar>
    </el-dialog>
  </div>
</template>

<script>
import { listLog } from "@/api/logxs/oper.js";

export default {
  data() {
    return {
      visible: false,
      loading: false,
      logs: [],
    };
  },
  methods: {
    show(sourceType, encrySourceId) {
      this.visible = true;
      this.loading = true;

      console.log(
        "查看日志sourceType,encrySourceId",
        sourceType,
        encrySourceId
      );

      listLog({ sourceType, encrySourceId }).then((res) => {
        this.logs = res;
        this.loading = false;
      });
    },
  },
};
</script>

 <style lang="scss" scoped>
.default-scrollbar {
  width: 100%;
  height: 70vh;
}

.el-scrollbar__wrap {
  overflow-x: hidden;
}
</style>